module.exports = __webpack_public_path__ + "static/media/files-management.29307318.jpg";